import axios from "axios";
const omiseSecretKey = import.meta.env.OMISE_SECRET_KEY;

export default function useOmise() {
  const getCard = async (customerId, cardToken) => {
    const response = await axios.get(
      `  https://api.omise.co/customers/${customerId}/cards/${cardToken}`,
      {
        auth: {
          username: omiseSecretKey,
          password: "",
        },
      }
    );

    return response?.data;
  };

  const addCard = async (customerId, cardToken) => {
    const response = await axios.patch(
      `https://api.omise.co/customers/${customerId}`,
      {
        card: cardToken,
      },
      {
        auth: {
          username: omiseSecretKey,
          password: "",
        },
      }
    );

    return response?.data;
  };

  const deleteCard = async (customerId, cardId) => {
    const response = await axios.delete(
      `https://api.omise.co/customers/${customerId}/cards/${cardId}`,
      {
        auth: {
          username: omiseSecretKey,
          password: "",
        },
      }
    );

    return response?.data;
  };

  return {
    getCard,
    addCard,
    deleteCard,
  };
}
